import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { DviLearningDashboardSummary } from '@/hooks/useDviLearningDashboard';
import { pct } from './stageColors';

interface Props {
  summary: DviLearningDashboardSummary | null | undefined;
}

export function AcceptanceBreakdownPanel({ summary }: Props) {
  if (!summary) return null;
  if (summary.accepted_count == null || summary.edited_count == null || summary.rejected_count == null) {
    // B-19 (P-05): acceptance counts are not available per shop; show that, never 0 / 0%.
    return (
      <Card>
        <CardHeader className="pb-2"><CardTitle className="text-sm">Acceptance Breakdown</CardTitle></CardHeader>
        <CardContent className="text-xs text-muted-foreground">Unavailable: no shop-level acceptance data.</CardContent>
      </Card>
    );
  }
  const total = summary.accepted_count + summary.edited_count + summary.rejected_count;
  const a = total ? summary.accepted_count / total : 0;
  const e = total ? summary.edited_count / total : 0;
  const r = total ? summary.rejected_count / total : 0;
  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-sm">Acceptance Breakdown</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <div className="flex h-3 w-full overflow-hidden rounded-full border border-border">
          <div className="bg-primary" style={{ width: `${a * 100}%` }} />
          <div className="bg-accent" style={{ width: `${e * 100}%` }} />
          <div className="bg-destructive" style={{ width: `${r * 100}%` }} />
        </div>
        <div className="grid grid-cols-3 gap-3 text-sm">
          <div><div className="text-xs text-muted-foreground">Accepted</div><div className="font-medium">{summary.accepted_count} · {pct(a)}</div></div>
          <div><div className="text-xs text-muted-foreground">Edited</div><div className="font-medium">{summary.edited_count} · {pct(e)}</div></div>
          <div><div className="text-xs text-muted-foreground">Rejected</div><div className="font-medium">{summary.rejected_count} · {pct(r)}</div></div>
        </div>
      </CardContent>
    </Card>
  );
}
